import { ReactNode } from 'react';
import styles from './styles/FilterSection.module.scss';

export default function FilterSection({ children }: { children: ReactNode }) {
  return <div className={styles.FilterSection}>{children}</div>;
}
